import { render, staticRenderFns } from "./Yu.vue?vue&type=template&id=0e23ab96&scoped=true"
import script from "./Yu.vue?vue&type=script&lang=js"
export * from "./Yu.vue?vue&type=script&lang=js"
import style0 from "./Yu.vue?vue&type=style&index=0&id=0e23ab96&prod&lang=scss"
import style1 from "./Yu.vue?vue&type=style&index=1&id=0e23ab96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23ab96",
  null
  
)

export default component.exports